import React from 'react';
import { FeatherIcon } from 'lucide-react';
export function AuthorControl() {
  return <div className="mx-auto mt-8 max-w-3xl rounded-2xl border-2 border-gold bg-grape-deep p-6 text-white sm:p-8" data-id="element-163" data-mp="1874fkm96k6g2">
      <h3 className="flex items-center gap-2 font-display text-lg font-black sm:text-xl" data-id="element-164" data-mp="1cy4chriauoik">
        <FeatherIcon className="h-5 w-5 shrink-0 text-gold-soft" aria-hidden="true" data-id="element-165" data-mp="1h0hjskcp2uhg" />
        Professional result — you stay in control
      </h3>
      <p className="mt-3 text-sm text-white/75" data-id="element-166" data-mp="kbjkqpxwwaeh">Instead of asking:</p>
      <p className="mt-1 font-display text-lg font-semibold italic text-white/60 line-through decoration-gold/70" data-id="element-167" data-mp="p9tgb1njtd0m">
        “Can you help me write my book?”
      </p>
      <p className="mt-3 text-base font-bold text-white" data-id="element-168" data-mp="y988c5jd5vn8">You give AI a structured instruction.</p>
      <ul className="mt-3 grid gap-1.5 text-sm text-white/85 sm:grid-cols-3" data-id="element-169" data-mp="24psky2xyiqw4">
        <li data-id="element-170" data-mp="24rwmie8dvdt8">You provide your information.</li>
        <li data-id="element-171" data-mp="29nlqquvclivv">AI follows the framework.</li>
        <li data-id="element-172" data-mp="29qq34fiyvkxm">You decide what stays.</li>
      </ul>
      <p className="mt-5 border-t border-gold/40 pt-4 font-display text-2xl font-black text-gold-soft" data-id="element-173" data-mp="3nhe1d1doq6jv">You remain the author.</p>
    </div>;
}